import { render } from "./EnterOrder.vue?vue&type=template&id=188b50d6&scoped=true"
import script from "./EnterOrder.vue?vue&type=script&lang=js"
export * from "./EnterOrder.vue?vue&type=script&lang=js"

import "./EnterOrder.vue?vue&type=style&index=0&id=188b50d6&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188b50d6"]])

export default __exports__